<div class="container-small">
    <div>
        <P>Vragen rond een project? <br />U heeft grond in bezit en deze is geschikt voor projectbouw?<br />Neem dan
            gerust contact op.<br /><br />Frank | 0475 26 28 28<br />Tom | 0475 11 01 01 </P>
    </div>
</div>
